import { useEffect, useState } from 'react';
import { Lightbulb, ChevronDown, ChevronUp } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';

/* =====================================================================
   ¿Esto te sirve? · DIRECTRIZ-TICKETS F7
   =====================================================================
   Mientras alguien escribe qué va a reportar, TEGO busca soluciones
   parecidas de SU empresa y las ofrece. Si alguna sirve, se lee ahí mismo y
   se evita abrir un ticket. Acotado a la empresa por el backend (RLS).

   No estorba: si no hay nada parecido, no se pinta nada. Busca en vivo con
   una pausa corta para no llamar por cada letra.
   ===================================================================== */
export default function SugerenciasArticulos({ texto }) {
  const [sugerencias, setSugerencias] = useState([]);
  const [abierta, setAbierta] = useState(null);   // id de la que está expandida

  useEffect(() => {
    const t = (texto || '').trim();
    let vivo = true;
    // Todo el cambio de estado vive dentro del temporizador (nunca síncrono
    // en el cuerpo del efecto): con menos de 4 letras se limpia, y con más
    // se busca tras la pausa.
    const tiempo = setTimeout(() => {
      if (!vivo) return;
      if (t.length < 4) { setSugerencias([]); return; }
      api.get(`/tickets/articulos/sugerencias?q=${encodeURIComponent(t)}`)
        .then((s) => { if (vivo) setSugerencias(Array.isArray(s) ? s : []); })
        .catch(() => { if (vivo) setSugerencias([]); });
    }, 350);
    return () => { vivo = false; clearTimeout(tiempo); };
  }, [texto]);

  if (sugerencias.length === 0) return null;

  return (
    <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-3">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <Lightbulb className="h-4 w-4" aria-hidden="true" /> ¿Esto te sirve?
      </p>
      <p className="mt-0.5 text-xs text-amber-800">
        Encontramos soluciones parecidas. Ábrelas por si ya resuelven lo tuyo.
      </p>
      <Ayuda id="sugerencias.antes_de_reportar" />
      <ul className="mt-2 flex flex-col gap-2">
        {sugerencias.map((s) => (
          <li key={s.id} className="rounded-lg border border-amber-200 bg-white">
            <button
              type="button"
              onClick={() => setAbierta(abierta === s.id ? null : s.id)}
              aria-expanded={abierta === s.id}
              className="flex min-h-[44px] w-full items-center justify-between gap-2 px-3 text-left"
            >
              <span className="min-w-0 truncate text-sm font-medium text-gray-900">{s.titulo}</span>
              {abierta === s.id
                ? <ChevronUp className="h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
                : <ChevronDown className="h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />}
            </button>
            {abierta === s.id && (
              <p className="whitespace-pre-wrap border-t border-amber-100 px-3 py-2 text-sm text-gray-800">
                {s.resumen}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
